import {Config} from '@/config';
import {BaseApi} from './BaseApi';
import {cacheObservableData, catchUnathorized} from './decorators';
import axios from 'axios';
import {from} from 'rxjs';

class TournamentsApi extends BaseApi {
  public buildApiUrl(path: string) {
    return `${Config.tournamentApiEndpoint}/hw_ajax.php?${path}`;
  }

  public getApiToken() {
    const w = window as any;
    return typeof w.getTournamentsApiAccessToken === 'function' ? w.getTournamentsApiAccessToken() : null;
  }

  @catchUnathorized()
  @cacheObservableData()
  public getCurrentTournamentUserInfo$() {
    return this.getJSON(`do=get_current_tournament_userinfo`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getTournamentUserInfo$(userId: number) {
    return this.getJSON(`do=get_tournament_userinfo&user_id=${userId}`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getTournamentReports(tournamentId: number) {
    return this.getJSON(`do=get_tournament_reports&tournament=${tournamentId}`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getTournamentRequests(tournamentId: number) {
    return this.getJSON(`do=get_tournament_requests&tournament=${tournamentId}`);
  }

  public updateTournamentRequest(forumThreadId: number, requestId: number, comment: string, isApproved: boolean) {
    const w = window as any;
    const encodedComment = w.PHP.urlencode(comment);
    return from(axios.post(
      `${Config.tournamentApiEndpoint}/showthread.php?t=${forumThreadId}&do=request_action`,
      {
        request: 1,
        id: requestId,
        comment: encodedComment,
        action: isApproved ? 'approve' : 'reject',
      },
    ));
  }
}

export const tournamentsApi = new TournamentsApi();
